<template>
  <v-app>
      <v-container>
          <form action="" class="rform justify-content-center">
                <div class="form-group row d-flex justify-content-center" style="margin-top:45px">
                    <h2 style="color:#1C2546">Inicia Sesión</h2>
                </div>    
                <v-row class="justify-content-center col-lg-12 flex">
                    <v-col lg="6">
                        <v-text-field
                            name="username"
                            label="Correo"
                            id="username"
                            v-model="auth.username"
                            :error="isUnAuth"
                            @change="isUnAuth=false"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="justify-content-center col-lg-12 flex">
                  <v-col lg="6">
                    <v-text-field
                          name="password"
                          label="Contraseña"
                          id="password"
                          :type="(isVisible?'text':'password')"
                          v-model="auth.password"
                          :error="isUnAuth"
                          @change="isUnAuth=false"
                          @keydown="pulsado"
                      >
                    <div slot="append">
                    <v-icon class="pointer" @click="visible">{{isVisible?'mdi-eye-off':'mdi-eye'}}</v-icon>
                    </div>   
                    </v-text-field>
                  </v-col>
                </v-row>       
                <v-row class="justify-content-center col-lg-12">      
                    <v-alert type="success" :value='alertSucess' close-text="Cerrar">
                        {{ message }}
                    </v-alert> 
                    <v-alert type="error" :value='alertError' close-text="Cerrar">
                        {{ message }}
                    </v-alert> 
                </v-row>
                <v-row class="justify-content-center col-lg-12 text-center">
                  <v-col lg="6">
                      <v-btn color="info" @click="login">Acceder</v-btn>
                  </v-col>
              </v-row>                            
                  
            
          </form>
      </v-container>
  </v-app>
</template>

<script>
import axios from 'axios'

export default {
    data(){
        return {
            isUnAuth: false,
            auth:{
                username: '',
                password: ''
            },
            isVisible: false,
            alertSucess: false,
            alertError: false,
            message: ""
        }
    },
    methods:{
      pulsado: function(evt){
            if(evt.key=='Enter')
            {
                this.login()
            }
        },
        login: async function(){
            if (this.validEmail(this.auth.username)) {
                axios.post('https://'+process.env.VUE_APP_URL+':3000/login/',this.auth)
                .then((response) => {
                    this.message = response.data.message;
                    if(response.data.message === 'Autenticación correcta'){
                        this.alertError = false;
                        this.alertSucess = true;
                        let user = {
                            nombre: response.data.body.nombre,
                            puesto: response.data.body.puesto,
                            tipo: response.data.body.tipo,
                            nivel_acceso: response.data.body.nivel_acceso,
                            id_puesto: response.data.body.id_puesto,
                            id_user: response.data.body.id_user
                        }
                        this.$store.commit('setUser',user);
                        this.$store.commit('setToken',response.data.body.token);
                        this.$router.push('/');
                    }else{
                        this.isUnAuth = true;
                        this.alertError = true;
                        this.alertSucess = false;
                    }
                });
            }else{
                this.message = 'Correo con formato inválido';
                this.isUnAuth = true;
                this.alertError = true;
                this.alertSucess = false;
            }
            /*
            try {
                let {data} =  await axios.post('https://127.0.0.1:3000/login',this.auth)
                //console.log(data)
                this.$store.commit('setToken',data.token)

            } catch (error) {
                //console.log(error)
                this.isUnAuth=true

            }*/           
        },
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        visible: function(){
            this.isVisible=!this.isVisible
        }
    },
    computed: {

    },
    mounted() {
        axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
        if (this.$route.params.errorToken) {
            this.message = "Token expirado, por favor inicie sesión de nuevo";
            this.alertError = true;
        }
    }
}
</script>

<style>
    .pointer {
        cursor: pointer;
    }
</style>